var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#f9f9fb"},attrs:{"id":"inspire"}},[_c('app-topbar'),_c('appSidebarr'),_c('v-main',{staticStyle:{"padding":"50px 10px 0px 256px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }